import { Environment } from './types';

const nico = 'SlhzDh7kVwN1ikjsatM9dgVBHLl1';

export const firebaseApiKey = 'AIzaSyB4Vo0jTxu1mmwcoUnzIMk6QoK-64dAl4o';
export const rollbarToken = '5cdd738c57014cd79e6019f0b748a730';

export const environment: Environment = {
  production: false,
  localLogin: true,
  name: 'demo',
  whiteList: {
    ids: [nico],
    theme: {
      licence: {
        handleSubscriptions: [nico],
        transfer: [nico]
      },
      workspace: {
        customOptions: [nico]
      },
      bot: {},
      user: {},
      utilities: {}
    }
  },
  domain: 'https://ideta-backoffice.web.app',
  backendUrl: 'https://api-test.ideta.io',
  products: {
    connect: 'https://connect-test.ideta.io',
    default: 'https://app-test.ideta.io',
    webhooks: 'https://webhooks-test.ideta.io',
    livechat: 'https://livechat-test.ideta.io',
    inbox: 'https://inbox-test.ideta.io',
    autocomment: 'https://private-replies-test.ideta.io'
  },
  firebase: {
    authDomain: 'app-test.ideta.io',
    databaseURL: 'https://trhs-sandbox1.firebaseio.com',
    projectId: 'trhs-sandbox1',
    storageBucket: 'trhs-sandbox1.appspot.com',
    messagingSenderId: '1059659963313'
  },
  rollbar: {
    active: false,
    buildVersion: 'd60500c'
  },
  appSettings: {
    billingTrialDuration: 20160,
    maxPaginatedUserListLength: 50,
    maxLastUserListLength: 100,
    typingVisualDelay: 1500,
    emptyTemplateImg: 'https://img.icons8.com/pastel-glyph/2x/empty-box.png',
    maxKeyNameLength: 100,
    maxPropertyNameLength: 100,
    delayBeforeCokcpitNodeResend: 5000,
    noNameNode: 'bulle_sans_nom',
    apiMaxTimeout: 10000,
    defaultTextSpeechLang: 'en_US',
    voiceNumberThreshold: 100000,
    maxKeepAliveDelay: 1440,
    systemKeyAsIdentifier: ['first_name', 'last_name', 'email', 'phone_number'],
    maxOperationsDisplayOnInit: 5,
    maxKeysDisplayOnInit: 15,
    maxDataKeyLength: 80,
    maxDataKeyLines: 11,
    maxExpandedWorkspaces: 5,
    minHeight: 500,
    minWidth: 500,
    notificationDelay: 5,
    testing: {
      threeColsRatio: 157,
      twoColsRatio: 120
    },
    embedded: {
      blurEventCode: 'v2bnpga',
      displayNotificationCode: 'z64tefu',
      resetNotificationCode: 'dj9y4b8',
      triggerInPageNavigationCode: 'k120eks',
      startEventCode: 'k257yt6',
      loadedEventCode: 's737sz2'
    }
  },
  defaults: {
    user: {
      avatarUrl: 'assets/img/avatar.svg'
    }
  }
};
